export { LetterAvatar } from './letter-avatar';
